define( function() {
	return "abbr|article|aside|audio|bdi|canvas|data|datalist|" +
		"details|dialog|figcaption|figure|footer|header|hgroup|main|" +
		"mark|meter|nav|output|picture|progress|section|summary|template|time|video";
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/manipulation/var/nodeNames.js
// module id = 45
// module chunks = 0